<template>
  <div class="custom-msg">
    <template v-if="customContent.type === 'card'">
      <card-message :custom-content="customContent" />
    </template>
    <template v-else-if="customContent.type === 'questionnaireView'">
      <questionnaire-view :custom-content="customContent" />
    </template>
    <template v-else-if="customContent.type === 'questionnaireViewForm'">
      <questionnaire-view-form :custom-content="customContent" />
    </template>
  </div>
</template>

<script>
import CardMessage from './CardMessage'
import QuestionnaireView from './QuestionnaireView'
import QuestionnaireViewForm from './QuestionnaireViewForm'
export default {
  name: 'CustomMsg',
  components: {
    CardMessage,
    QuestionnaireView,
    QuestionnaireViewForm
  },
  props: {
    msg: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    customContent () {
      return JSON.parse(this.msg.content)
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/CustomMsg.vue